import { customTheme } from 'theme';

export const tagContainerStyles = {
  border: '1px solid',
  borderRadius: 6,
  borderColor: customTheme.colors.gray['100'],
  p: 2,
};
